<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Black </span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-2">and</span><span class="CharOverride-1"> </span></p>
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Resilient</span></p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-3">52 Weeks of Anti-Racist Activities for Black Joy<br/>and Empowerment</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-4">M.J. Fievre</span></p>
<p class="Basic-Paragraph ParaOverride-4"><span class="CharOverride-5"><img alt="" src="image/Mango_Publishing_Group.png"/></span></p>
<p class="Basic-Paragraph ParaOverride-5"><span class="CharOverride-6">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BlackAndResilient1.vue?28b7dbf1